import React from "react";
import { SiReact, SiJavascript } from "react-icons/si";

import pokemonAppReactImg from "../../../img/projects/pokemon_app_react.webp";
import pokemonImgPhone from "../../../img/projects/phone/pokemon-phone.webp";
import programmersAgentImg from "../../../img/projects/programmer's Agent.webp";
import programmersAgentImgPhone from "../../../img/projects/phone/programers-agent-phone.webp";
import skockoImg from "../../../img/projects/skocko.webp";
import skockoImgPhone from "../../../img/projects/phone/skocko-phone.webp";
import cocktailsAppImg from "../../../img/projects/cocktailapp.webp";
import cocktailsImgPhone from "../../../img/projects/phone/cocktailsapp-phone.webp";
import izzumPic from "../../../img/projects/izzumtechology.webp";
import izzumPicPhone from "../../../img/projects/phone/izzumtechnology-phone.webp";

import bankistAppImg from "../../../img/projects/bankist_app.webp";
import bankistWebsiteImg from "../../../img/projects/bankist_website.webp";
import bankistImgPhone from "../../../img/projects/phone/baknist-phone.webp";
import geographyAppImg from "../../../img/projects/geocountry.webp";
import geographyImgPhone from "../../../img/projects/phone/geography-phone.webp";
import diceGameImg from "../../../img/projects/dice_game.webp";
import diceGameImgPhone from "../../../img/projects/phone/dice-game-phone.webp";
import guesNumbGameImg from "../../../img/projects/guess_game.webp";
import numberGuessImgPhone from "../../../img/projects/phone/number-phone.webp";
import maptyImgPhone from "../../../img/projects/phone/mapty-phone.webp";
import maptyImg from "../../../img/projects/mapty.webp";
import rpsImg from "../../../img/projects/rps.webp";
import rpsImgPhone from "../../../img/projects/phone/rps-phone.webp";

export const reactProjectsData = [
  {
    id: 1,
    code: "React & JS",
    href: "projects/pokemon",
    title: (
      <>
        React <span>vs</span> JavaScript
      </>
    ),
    subtitle: "A Case Study of Pokemon Application",
    subtitleList: "case study",
    tags: "pokemon application",
    images: [{ img: pokemonAppReactImg, imgPhone: pokemonImgPhone }],
    link: [
      { text: "React app", url: "https://pokemon-app-reactapp.netlify.app/" },
      { text: "JavaSript app", url: "https://pokemonapp-2022.netlify.app/" },
    ],
    git: [
      {
        text: <SiReact className="icon-link" />,
        link: "https://github.com/popovic-nedeljko/Pokemon-application-ReactJS",
      },
      {
        text: <SiJavascript className="icon-link" />,
        link: "https://github.com/popovic-nedeljko/PokemonApp-JS",
      },
    ],
    info: [
      "The Pokemon application lets fans browse over 1,000 Pokemon, check detailed stats, and save favorites through a clean, intuitive interface.",
      "The app was built twice — once in JavaScript, once in React — to directly compare the two approaches.",
      "JavaScript version: built with OOP and an MVC architecture, which encapsulates data well and is familiar to developers coming from Java or C++.",
      "React version: built with functional programming and hooks, leading to more concise code, easier component reuse, and simpler performance optimization through memoization. The trade-off is weaker SEO out of the box.",
      "The right choice ultimately depends on the project's requirements — OOP/MVC for structure and familiarity, functional/React for composability and performance.",
    ],
  },
  {
    id: 3,
    code: "React",
    href: "projects/skocko",
    title: "Skočko game",
    subtitle: "Challenge your logic and play",
    subtitleList: "game app",
    tags: "powered by react",
    images: [{ img: skockoImg, imgPhone: skockoImgPhone }],
    link: [{ text: "Play", url: "https://skocko-game-2023.netlify.app/" }],
    git: [
      {
        text: "code",
        link: "https://github.com/popovic-nedeljko/Skocko-Game-ReactJS",
      },
    ],
    info: [
      "Skočko is a logic game inspired by the classic Slagalica quiz: players must guess the correct combination of symbols within a limited time, narrowing it down through feedback after each guess.",
      "Built with modular React components and hooks — AppProvider and AppContext share game state via useContext, while an async timer and a custom matching algorithm drive the core gameplay. Styled with SCSS for a clean, responsive layout.",
    ],
  },
  {
    id: 5,
    code: "React, Vite & SASS",
    href: "izzumtechnology",
    title: "Izzum Technology",
    subtitle: "Interactive Sports-Tech & Smart Devices Platform",
    subtitleList: "website",
    tags: "client project",
    images: [{ img: izzumPic, imgPhone: izzumPicPhone }],
    link: [{ text: "Visit website", url: "https://izzumtechnology.com/" }],
    git: [],
    info: [
      "A fully responsive, SEO-optimized platform for Izzum Technology, built to showcase and sell interactive smart training and gaming devices — including the Challenger Reaction Board, Challenger Mini, IC Prox Sensor System, and SPACEMAN Score Counter.",
      "Built with React, TypeScript, Vite, and SASS, with multilingual support and a dark/light theme.",
      "Scope covered full UI/UX design, custom animations, backend email integration for contact forms, domain configuration and deployment, and performance/loading-speed optimization.",
      "The result is a fast, visually engaging platform that presents the products clearly to children, athletes, and recreational users alike.",
    ],
  },
  {
    id: 6,
    code: "Vite + React",
    href: "projects/rps-arcade",
    title: "RPS Arcade",
    subtitle: "Rock, Paper, Scissors gaming hub",
    subtitleList: "game app",
    tags: "vite + react project",
    images: [{ img: rpsImg, imgPhone: rpsImgPhone }],
    link: [{ text: "Play now", url: "https://rps-arc.netlify.app/" }],
    git: [
      {
        text: "code",
        link: "https://github.com/popovic-nedeljko/Rock_paper_sissors",
      },
    ],
    info: [
      "RPS Arcade is an interactive Rock-Paper-Scissors gaming hub with a flashy, neon-themed landing page offering three game modes — a 'vs CPU' mode that's fully playable, plus 'Tournament' and '1v1 Online' modes shown as 'coming soon'. The CPU mode lets players battle an AI opponent in a best-of-3, best-of-5, or best-of-10 match, choosing between a 'Standard' (random) or 'Hard' (pattern-reading) difficulty.",
      "Each round plays out in an animated arena where both fighters reveal their move (rock/paper/scissors) with a brief 'thinking' suspense animation before the result pops in, highlighting the winner and shaking the loser. The UI tracks live score, a round-by-round streak of win/lose/draw dots, and cumulative lifetime stats (total wins/losses/draws) shown in the header, wrapping up with a Victory/Defeat overlay and a 'Play Again' option at match end. A login/signup modal with email and social-login (Google, X) placeholders is also included on the landing page.",
      "Built with React 19 and Vite, the app uses a useReducer-based custom hook (useRPSGame) to manage all game state and phase transitions ('idle' → 'revealing' → 'revealed'/'done'), plus keyboard shortcuts (1/2/3) for fast play. The 'Hard' AI difficulty implements a simple pattern-detection algorithm: it tracks the player's last 3 moves, identifies their most frequent choice, and counters it 70% of the time (falling back to random otherwise) to simulate adaptive opponent behavior. Styling is done with SCSS modules per component, giving each piece (Arena, ScoreRail, WeaponCards, ControlDeck, GameOver, etc.) its own scoped neon-arcade visual style.",
    ],
  },
  {
    id: 2,
    code: "React & SASS",
    href: "programmers-agent",
    title: "Programmer's agent",
    subtitle: "revolution in representation of talent",
    subtitleList: "website",
    tags: "pet project",
    images: [{ img: programmersAgentImg, imgPhone: programmersAgentImgPhone }],
    link: [
      { text: "Visit website", url: "https://programmersagent.netlify.app/" },
    ],
    git: [],
    info: [
      "A responsive website built with React and SASS that simplifies the job search for senior developers, with a clean interface focused on usability.",
      "It connects experienced programmers directly with forward-thinking tech companies, offering personalized representation instead of a generic job board — making the hiring process faster and more human.",
    ],
  },
  {
    id: 4,
    code: "React",
    href: "projects/cocktails",
    title: "the Cocktail",
    subtitle: "Find Your Perfect Cocktail Recipe",
    subtitleList: "application",
    tags: "react course",
    images: [{ img: cocktailsAppImg, imgPhone: cocktailsImgPhone }],
    link: [
      {
        text: "Explore app",
        url: "https://cocktail-application-2022.netlify.app/",
      },
    ],
    git: [
      {
        text: "code",
        link: "https://github.com/popovic-nedeljko/Cocktails-API-router-ReactJS",
      },
    ],
    info: [
      "A cocktail recipe search engine that lets users search for drinks and instantly find matching recipes — built for cocktail enthusiasts looking to discover something new to try.",
      "Powered by TheCocktailDB API, giving access to a large library of recipes with ingredients and step-by-step instructions.",
      "Built with a component-based structure and a custom context provider using useContext for state. Data is fetched asynchronously and normalized into a lookup object for fast filtering, React Router handles navigation, and failed API requests show a clear error message instead of breaking the UI.",
    ],
  },
];

export const javaScriptProjectsData = [
  {
    id: 1,
    code: "JavaScript",
    href: "projects/mapty",
    title: "Mapty",
    subtitle: "Track your workouts on the map",
    subtitleList: "application",
    tags: "JavaScript project",
    images: [{ img: maptyImg, imgPhone: maptyImgPhone }],
    link: [
      {
        text: "Explore app",
        url: "https://run-cycle-app.netlify.app/",
      },
    ],
    git: [
      {
        text: "code",
        link: "https://github.com/popovic-nedeljko/mapty_app",
      },
    ],
    info: [
      "Mapty is an interactive fitness tracking application that allows users to log running and cycling workouts directly on an interactive map. By clicking any location on the map, users can record workout details such as distance, duration, cadence, pace, and elevation gain, with each entry pinned as a marker at the exact GPS coordinates.",
      "The application automatically fetches real-time weather data for each workout location, displays workout history with filtering and sorting options, and presents a statistics panel with bar charts showing weekly and monthly activity trends. All workout data persists across sessions using LocalStorage, and the app is available as a Progressive Web App (PWA) with offline support via a service worker.",
      "This application was built with vanilla JavaScript using object-oriented programming with ES6 classes and private class fields. It leverages the Geolocation API, the Leaflet.js mapping library, the Open-Meteo weather API, and Chart.js for data visualization. Key techniques include asynchronous programming with async/await, event delegation, DOM manipulation, the Haversine formula for distance calculation, and a custom route-drawing mode that lets users trace multi-point paths on the map.",
    ],
  },
  {
    id: 3,
    code: "JavaScript",
    href: "projects/bankist-account",
    title: "Bankist account",
    subtitle: "Manage your finances like a pro",
    subtitleList: "application",
    tags: "JavaScript app",
    images: [{ img: bankistAppImg }],
    link: [
      {
        text: "Explore app",
        url: "https://bankist-bankaccountapp.netlify.app/",
      },
    ],
    git: [
      {
        text: "code",
        link: "https://github.com/popovic-nedeljko/Bankist--bank-account-app",
      },
    ],
    info: [
      "An interactive banking app with a responsive interface for checking balances, transferring money, requesting loans, and closing accounts.",
      "Every account tracks transaction history and interest rates, generating clear financial summaries so users can monitor spending and progress toward goals.",
      "Built with vanilla JavaScript: authentication, real-time UI updates, array methods for transaction processing, and an event-driven architecture for fast DOM updates.",
    ],
  },
  {
    id: 2,
    code: "JavaScript",
    href: "projects/bankist",
    title: "Bankist",
    subtitle: "Experience modern banking",
    subtitleList: "website",
    tags: "JavaScript project",
    images: [{ img: bankistWebsiteImg, imgPhone: bankistImgPhone }],
    link: [
      {
        text: "Access website",
        url: "https://bankist-bankswebsite.netlify.app/",
      },
    ],
    git: [
      {
        text: "code",
        link: "https://github.com/popovic-nedeljko/Bankist-banks-website-JS",
      },
    ],
    info: [
      "A banking marketing site with modal windows, scroll animations, and tabbed components for an engaging browsing experience.",
      "Uses event listeners and DOM manipulation for sticky navigation, lazy-loaded images, and a custom slider component.",
      "Intersection Observers handle lazy loading and scroll-triggered animations, keeping the site fast while still feeling dynamic.",
    ],
  },

  {
    id: 4,
    code: "JavaScript",
    href: "projects/geography",
    title: "Geography",
    subtitle: "Explore the world",
    subtitleList: "mini application",
    tags: "JavaScript app",
    images: [{ img: geographyAppImg, imgPhone: geographyImgPhone }],
    link: [{ text: "Open now", url: "https://geographyapp.netlify.app/" }],
    git: [
      {
        text: "code",
        link: "https://github.com/popovic-nedeljko/GeographyApp-JS",
      },
    ],
    info: [
      "A country lookup app powered by the REST Countries API: search any country and see its key data rendered dynamically via DOM manipulation.",
      "Clear error handling guides the user when a search fails or input is invalid, instead of failing silently.",
      "Selecting a country also shows its neighboring countries, and the Geolocation API can detect and display the user's current location automatically.",
    ],
  },
  {
    id: 5,
    code: "JavaScript",
    href: "projects/dice-game",
    title: "Dice game",
    subtitle: "Roll the dice and test your luck",
    subtitleList: "game app",
    tags: "JavaScript",
    images: [{ img: diceGameImg, imgPhone: diceGameImgPhone }],
    link: [{ text: "Play now", url: "https://dice-pig.netlify.app/" }],
    git: [
      {
        text: "code",
        link: "https://github.com/popovic-nedeljko/Pig-game--dice-game-app-JS",
      },
    ],
    info: [
      "A two-player dice game (inspired by Pig) where players roll to accumulate points, built with vanilla JavaScript and DOM manipulation for live score and status updates.",
      "A random number generator simulates the dice roll — rolling 6-6 wipes the active player's accumulated points for the turn. Players can set a custom winning score, switch turns, and start a new game with one click.",
    ],
  },
  {
    id: 6,
    code: "JavaScript",
    href: "projects/guess-number-game",
    title: "Guess the number Game",
    subtitle: "Put Your Guessing Skills to the Test",
    subtitleList: "game app",
    tags: "JavaScript",
    images: [{ img: guesNumbGameImg, imgPhone: numberGuessImgPhone }],
    link: [
      {
        text: "Visit now & play",
        url: "https://guess-my-number-simple-app.netlify.app/",
      },
    ],
    git: [
      {
        text: "code",
        link: "https://github.com/popovic-nedeljko/Guess-my-number-simple-app",
      },
    ],
    info: [
      "A simple number-guessing game: the player tries to guess a hidden number within a limited number of attempts, with instant feedback after each guess (too high, too low, correct).",
      "A highscore tracks the player's best result across games, and a reset button starts a fresh round at any time.",
      "Built with vanilla JavaScript — DOM manipulation, conditional logic, and a random number generator drive the core gameplay, with responsive feedback messages built using template literals.",
    ],
  },
];

export const projectContainerData = [
  {
    id: 1,
    name: "React",
    icon: <SiReact className="projects-container-header-icon icons-react" />,
    projectData: reactProjectsData,
  },
  {
    id: 2,
    name: "JavaScript",
    icon: (
      <SiJavascript className="projects-container-header-icon icons-javaScript" />
    ),
    projectData: javaScriptProjectsData,
  },
];
